module.exports = {
    desktop: ['netboard_1', 'netboard_2', 'netboard_3'], // same as tablet
    mobile: ['board_1', 'board_2', 'board_3'],
    extraSizes: {
        tablet: {
            'no-vg-{deviceType}-article_topboard': [[980, 250]],
        },
    },
};



/** WEBPACK FOOTER **
 ** ./src/ads/config.js
 **/